import { FieldStub } from "./_FieldStub";
import type { FieldPrimitiveProps } from "./types";

// STUB — CHG-1167 scaffold. Real impl lands ε CHG-1153 (designations sweep).
// Contract: specs/_product/field-primitive-registry.md §1 ('tag_input').
// Doctrine: feedback_field_primitive_components_canonical.md.

export function TagInput(props: FieldPrimitiveProps<string>) {
  return <FieldStub {...props} fieldType="tag_input" inputType="text" />;
}
